// assets/a24-ajax-cart.js
/* Product-page AJAX add-to-cart and header cart badge updates. */
(function () {
  'use strict';

  function updateHeaderCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? '' : 'none';
    });

    var cartLink = document.querySelector('.header__action[aria-label="Warenkorb"]');
    var badge = document.getElementById('cartBadge');

    if (count <= 0) {
      if (badge) badge.remove();
      return;
    }

    if (!badge && cartLink) {
      badge = document.createElement('span');
      badge.id = 'cartBadge';
      badge.style.cssText = 'position:absolute;top:-4px;right:-6px;background:#2563eb;color:#fff;border-radius:50%;font-size:10px;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-weight:700;line-height:1;';
      var labelEl = cartLink.querySelector('.header__action-label');
      cartLink.insertBefore(badge, labelEl || null);
    }

    if (badge) {
      badge.textContent = String(count);
    }
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(function (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var self = this;
      var formData = new FormData(this);
      var btn = this.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (r) {
        if (!r.ok) {
          /* Store password protected or other error – fall back to native submit */
          self.submit();
          return Promise.reject('fallback');
        }
        return r.json();
      })
      .then(function () {
        /* Update cart count */
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count);
        if (btn) { btn.disabled = false; btn.textContent = '✓ Hinzugefügt'; }
        setTimeout(function () {
          if (btn) btn.textContent = 'In den Warenkorb';
        }, 2000);
      })
      .catch(function (err) {
        if (err === 'fallback') return;
        /* Unexpected error – fallback to native submit */
        if (btn) { btn.disabled = false; }
        self.submit();
      });
    });
  });
}());
